var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AbButton,_vm._b({attrs:{"variant":_setup.currentVariant},on:{"click":_setup.clickEvent}},'AbButton',_setup.props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }